module.exports = __webpack_public_path__ + "img/1.980789b7.png";